<template>
    <section :class="['modal-mask', passedProps.customClass ]">
        <div class="modal-wrapper">
            <div class="modal-container" v-click-outside="closeOpenModal">
                <div class="modal-body" :style="!!passedProps.style ? passedProps.style.body : {}">
                    <img v-if="!!passedProps.type" :class="['visual-aid', passedProps.type]" :src="'/material/img/modals/' + passedProps.type + '.png'" :alt="passedProps.type">
                    <p v-html="handleDescription()"></p>
                </div>
                <div class="modal-footer">
                    <div v-if="!!passedProps.confirmBtnText"
                         @click="userAcceptedAction"
                         :class="['btn', { 'bg-deep-orange': passedProps.type === 'confirm-edit' }]">
                        {{ passedProps.confirmBtnText }}
                    </div>
                    <div v-if="!!passedProps.confirmBtnText"
                         class="btn grey lighten modal-cancel-btn"
                         @click="userCancelAction">{{ cancelBtnText }}</div>
                    <div v-else
                         class="btn grey lighten modal-close-btn"
                         @click="userCancelAction">{{ closeBtnText }}</div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "UserInteraction",
        props: {
            passedProps: Object
        },
        computed: {
            cancelBtnText() {
                return !!this.passedProps.cancelBtnText ? this.passedProps.cancelBtnText : this.$options.filters.lang('modals/cancel');
            },
            closeBtnText() {
                return this.$options.filters.lang('modals/close');
            }
        },
        methods: {
            userCancelAction() {
                this.$store.dispatch('triggerModalCallbackCancel', false)
                this.closeOpenModal();
            },

            userAcceptedAction() {
                this.$store.dispatch('triggerModalCallback', true)

                this.$emit('userAcceptedAction', true);
            },

            handleDescription() {
                const desc = this.passedProps.description;
                const descTranslation = this.$options.filters.lang(desc);

                if (desc === descTranslation) {
                    return desc;
                }

                return descTranslation;
            }
        }
    }
</script>

<style scoped lang="scss">
    .btn.bg-deep-orange:hover {
        background-color: rgba($deep-orange, 0.75);
    }

    .visual-aid {
        margin-bottom: 28px;

        &.confirm-action {
            width: 155px;
            height: 113px;
        }

        &.confirm-edit {
            width: 155px;
            height: 132px;
        }

        &.success {
            width: 155px;
            height: 167px;
        }
    }

    .btn {
        margin-left: 32px;

        &:first-of-type {
            margin-left: 0;
        }
    }
</style>